<template>
    <div class="d-flex w-110">
      
      <div class="info-details">
        <h5>{{$t('stats.clients.first')}}</h5>
        <h2>
          {{ values.new_clients }}
        </h2>
        <!-- <p>
          <small class="green">+5%</small> since last week
        </p> -->
        <h5 class="pt-20">{{$t('stats.clients.returning')}}</h5>
        <h2>
          {{ values.returning_clients}}
        </h2>
        <!-- <p>
          <small class="red">-5%</small> since last week
        </p> -->
        
        <div class="legend">
          <div class="legend-label">
            <span class="legend-icon green"></span> {{$t('stats.clients.new')}}
          </div>
          <div class="legend-label">
            <span class="legend-icon darkgreen"></span> {{$t('stats.clients.old')}}
          </div>
        </div>
      </div>
    </div>
</template>

<style scoped>


.chart-container {
  width: min-content;
  margin-top: 3.3vh;
  display: block;
}

.w-110 {
  width: 110%;
}

small.red {
  color: #e2223b;
}

small.green {
  color: #11d180;
}

.pt-20 {
  padding-top: 2.2vh;
}

h2 {
  font-size: 4.4vh;
  margin: 0;
}

h2 span {
  font-size: 2vh;
}


.label {
  display: flex;
  flex-flow: row wrap;
  transform: translateY(15%);
  color: #ededed;
  width: 80%;
  position: relative;
  top: 5vh;
  font-size: 2vh;
  align-items: flex-end;
  align-items: baseline;
  line-height: normal;
}

.label .line {
  width: 4vh;
  margin: 1.1vh 2.2vh 0 0;
  height: 1vh;
  display: inherit;
  background: red;
}

.label .line.blue {
  background: #cbd9e6;
}
.label .line.yellow {
  background: #ffd2a8;
}
.label .line.green {
  background: #129b81;
}

.label .line.darkgreen {
  background: #194F44;
}

/* GOOD CODE */

.legend {
  position: absolute;
  bottom: 4vh;
}

.legend-icon {
  width: 4vh;
  margin: 1.1vh 2.2vh 0 0;
  height: 1vh;
  display: inline-block;
}

.legend-icon.darkgreen {
  background: #194F44;
}

.legend-icon.green {
  background: #129b81;
}

.legend-label {
  color: #ededed;
  font-size: 2vh;
}

/* GOOD CODE END */

h4 span {
  color: #ededed;

}


h4.active {
  border-bottom: 5px solid #bde1e4;
  color: #ededed;
}

h3,
h4,
h5,
p {
  margin-bottom: 0;
}

h5 {
  font-size: 1.8vh;
}

p {
  font-size: 1.5vh;
  color: #a4a3a1;
  line-height: 0.8;
}

h4,
h3 span {
  font-size: 1.8vh;
}
.info-details {
  background: #1d1d1b;
  height: auto;
  color: #ededed;
  margin-left: -1vh;
  border-radius: 0 0 1vh 0;
  padding: 3.3vh 0 3.3vh 3vh;
   width: inherit;
  position: relative;
}
</style>

<script>
export default {
  props: {
    values: {
      type: Object,
      default: () => {
        return {
          new_clients: 0,
          returning_clients: 0
        }
      }
    }
  }
}
</script>